"use client";

import * as Popover from "@radix-ui/react-popover";

import useShowroom, {
  useLogoutShowroomUser,
  useShowroomBuyer,
} from "@/lib/showroom/hooks/useShowroom";

import { ShowroomBuyerSelect } from "../ShowroomBuyerSelect";
import styles from "./showroom-modal.module.css";

const ShowroomModal = () => {
  const { data } = useShowroom();
  const { buyerId, setBuyerId } = useShowroomBuyer();
  const { logout } = useLogoutShowroomUser();

  // const [selectedBuyer, setSelectedBuyer] = useState<string | null>(null);

  if (!data?.user) return null;

  return (
    <div className={styles.wrapper}>
      <Popover.Root>
        <Popover.Trigger>{data.user?.name}</Popover.Trigger>
        <Popover.Content className={styles.content}>
          <Popover.Arrow className={styles.arrow} />
          <p>Showroom</p>
          {data?.buyers && (
            <ShowroomBuyerSelect
              value={buyerId}
              onBuyerChange={setBuyerId}
              buyers={data?.buyers}
            />
          )}
          <br />
          <button className={styles.button} onClick={logout}>
            Logg ut
          </button>
        </Popover.Content>
      </Popover.Root>
    </div>
  );
};

export default ShowroomModal;
